import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "revico-community-talk-reply-post",
  ref: "replyPostSection"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 1,
  class: "revico-community-talk-reply-post-post-area"
}
const _hoisted_5 = { class: "revico-community-talk-reply-post--postbutton-wrapper" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 投稿する")
const _hoisted_8 = { class: "revico-community-talk-reply-post" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'tr_' + $setup.replyPostStore.getTalkRoomId(),
      class: "after-post-position"
    }, null, 8 /* PROPS */, _hoisted_1),
    ($setup.isFormVisible)
      ? (_openBlock(), _createBlock($setup["ApiPostLoadMaster"], {
          key: 0,
          status: $setup.status
        }, {
          beforeRequest: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              _createCommentVNode(" EC会員のみ可能な投稿許可の場合、ログインしてなければ訴求文言表示 "),
              (!$setup.isPostable)
                ? (_openBlock(), _createBlock($setup["RequireLogin"], { key: 0 }))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                type: "button",
                class: "revico-community-talk-reply-post--area-toggle-button",
                disabled: !$setup.isEnabledFormOpenButton(),
                onClick: $setup.toggleArea
              }, [
                (!$setup.replyPostStore.getIsDisplayReplyPostArea())
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "fa-solid fa-angle-right"
                    }))
                  : _createCommentVNode("v-if", true),
                ($setup.replyPostStore.getIsDisplayReplyPostArea())
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      icon: "fa-solid fa-angle-down"
                    }))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(" " + _toDisplayString($props.wordSettings.replyPostButtonDisplayName), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_3),
              ($setup.replyPostStore.getIsDisplayReplyPostArea() && $setup.isPostable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createCommentVNode(" 内容 "),
                    _createVNode($setup["ReplyPostContents"], {
                      replyPostStoreKey: $props.replyPostStoreKey,
                      apiValidationErrorViewModel: $setup.apiValidationErrorViewModel,
                      showRequiredError: $setup.isContentsEmpty
                    }, null, 8 /* PROPS */, ["replyPostStoreKey", "apiValidationErrorViewModel", "showRequiredError"]),
                    _createCommentVNode(" 画像・動画投稿"),
                    _createVNode($setup["ReplyPostMedia"], {
                      communityTalkStoreKey: $props.communityTalkStoreKey,
                      replyPostStoreKey: $props.replyPostStoreKey,
                      disabled: !$setup.isPostable,
                      onOnStartPostProcess: $setup.onStartMediaPostProcess,
                      onOnEndPostProcess: $setup.onEndMediaPostProcess
                    }, null, 8 /* PROPS */, ["communityTalkStoreKey", "replyPostStoreKey", "disabled"]),
                    _createCommentVNode(" ニックネーム "),
                    _createVNode($setup["PostNickName"], {
                      communityTalkStoreKey: $props.communityTalkStoreKey,
                      postType: "Reply",
                      disabled: !$setup.isPostable,
                      apiValidationErrorViewModel: $setup.apiValidationErrorViewModel,
                      showRequiredError: $setup.isNickNameEmpty
                    }, null, 8 /* PROPS */, ["communityTalkStoreKey", "disabled", "apiValidationErrorViewModel", "showRequiredError"]),
                    _createCommentVNode(" プロフィール画像 "),
                    _createVNode($setup["PostProfilePicture"], {
                      communityTalkStoreKey: $props.communityTalkStoreKey,
                      disabled: !$setup.isPostable,
                      apiValidationErrorViewModel: $setup.apiValidationErrorViewModel,
                      postType: "Reply"
                    }, null, 8 /* PROPS */, ["communityTalkStoreKey", "disabled", "apiValidationErrorViewModel"]),
                    _createCommentVNode(" 投稿者プロフィール "),
                    _createVNode($setup["PostReviewerAttribute"], {
                      communityTalkStoreKey: $props.communityTalkStoreKey,
                      disabled: !$setup.isPostable,
                      apiValidationErrorViewModel: $setup.apiValidationErrorViewModel
                    }, null, 8 /* PROPS */, ["communityTalkStoreKey", "disabled", "apiValidationErrorViewModel"]),
                    _createCommentVNode(" 投稿ボタン "),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("button", {
                        type: "button",
                        disabled: !$setup.isEnabledPostButton(),
                        onClick: $setup.post,
                        class: "revico-community-talk-reply-post--postbutton"
                      }, [
                        _hoisted_7,
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-paper-plane" })
                      ], 8 /* PROPS */, _hoisted_6)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */)
          ]),
          afterApiSuccess: _withCtx(() => [
            _createElementVNode("section", _hoisted_8, [
              _createVNode($setup["PostComplete"], null, {
                contents: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.wordSettings.replyPostCompleteText), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["status"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}